import { graphql } from 'gql';

export const bimWorkOrderChangeOtherDataGql = graphql(`
    query bimWorkOrderChangeOtherData($workOrderOtherPriceId: Long, $workOrderChangeOtherPriceId: Long) {
        bimWorkOrderChangeOtherData(
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            data {
                otherCostLimits {
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                }
                id
                contractId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                formula
                status
                isGlobalOtherCost
                rationale
                catalogOtherCostTypeId
                catalogOtherCostType {
                    canDelete
                    id
                    isSystem
                    name
                    uniqueId
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderChangeOtherGql = graphql(`
    mutation bimUpdateWorkOrderChangeOther(
        $workOrderChangeOtherPriceId: Long!
        $input: BimContractOtherCostUpdateInput!
    ) {
        bimUpdateWorkOrderChangeOther(workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId, input: $input) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
